<template>
  <div class="time-input form-control" :id="id">
    <vue-timepicker v-model="d_value" auto-scroll class="d-block" close-on-complete :disabled="disabled || readonly" hide-clear-button :hour-label="$t('input.label.hour')" input-class="form-control skip-error-style" :manual-input="!readonly"	:minute-label="$t('input.label.minute')" />
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src'

export default {
  name: 'form-time-input',
  components: { VueTimepicker },
  props: {
    disabled: Boolean,
    id: String,
    placeholder: String,
    readonly: Boolean,
    value: String,
  },
  data () {
    return {
      d_value: this.value,
    };
  },
  watch: {
    d_value () {
      this.$emit('input', this.d_value);
    },
    value () {
      this.d_value = this.value;
    },
  },
};
</script>
